import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import ModalService from "src/modals"
import {
  cancelMovement,
  clearSelectedCity,
  clearStrike,
  selectCreatingMovement,
  selectPickingOrigin,
  selectSelectedCity,
  selectStrikeOrigin,
  stopPickingOrigin,
} from "src/store/ui"

/* Escape on the map backs out one layer at a time: a modal (ModalService closes that itself), then
   a march being planned, then missile targeting, then "march here"'s origin list, then the selected
   cell's bar. One key, always "undo the mode I am in", never two things at once.

   So a press that closed a modal stops there — the city sheet's Escape is its ✕, and the cell
   stays selected under the action bar (owner, 2026-09-30). `closedAModal` is asked first, because
   from a real keyboard the stack has usually re-rendered empty before this listener runs (see
   `modals.js`); `hasOpenModals` still covers a modal that Escape did not close. */
const useEscapeBacksOut = () => {
  const dispatch = useDispatch()
  const selectedCity = useSelector(selectSelectedCity)
  const creatingMovement = useSelector(selectCreatingMovement)
  const strikeOrigin = useSelector(selectStrikeOrigin)
  const pickingOrigin = useSelector(selectPickingOrigin)

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key !== "Escape") return
      if (ModalService.closedAModal(e) || ModalService.hasOpenModals()) return
      if (creatingMovement) dispatch(cancelMovement())
      else if (strikeOrigin) dispatch(clearStrike())
      else if (pickingOrigin) dispatch(stopPickingOrigin())
      else if (selectedCity) dispatch(clearSelectedCity())
    }
    window.addEventListener("keydown", onKeyDown)
    return () => window.removeEventListener("keydown", onKeyDown)
  }, [creatingMovement, strikeOrigin, pickingOrigin, selectedCity, dispatch])
}

export default useEscapeBacksOut
